module.exports = __webpack_public_path__ + "img/verhuisd.3b57390e.png";